<template>
  <b-modal id="bv-modal-advertising-show" hide-footer size="lg">
    <template #modal-header>
      <h4>{{ $t("show_advertising") }}</h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('bv-modal-advertising-show')"
      >
        <i class="fas fa-times"></i>
      </b-button>
    </template>
    <b-form class="auth-register-form mb-4">
      <b-overlay
        :show="promotionsLoading"
        class="rounded"
        variant="transparent"
      >
        <template #overlay>
          <b-img
            width="100"
            :src="require('@/assets/img/brand/loader.gif')"
            alt=""
          />
        </template>
        <b-row>
          <b-col :xs="12" :sm="12" :md="12" :lg="3" class="text-center">
            <div
              style="cursor: pointer"
              id="pick-image"
              class="table-text mt-md-1"
            >
              <b-avatar
                button
                @click="previewImagen(preview)"
                rounded="sm"
                :src="preview"
                size="150px"
              >
              </b-avatar>
            </div>
          </b-col>
          <!-- TITLE -->
          <b-col :xs="12" :sm="12" :md="12" :lg="9">
            <b-row class="table-text">
              <b-col :md="5">
                <strong> {{ $t("form.name") }}: </strong>
              </b-col>
              <b-col :md="7">
                {{ data.name }}
              </b-col>

              <!-- TYPE -->
              <b-col :md="5">
                <strong> {{ $t("form.amount") }}: </strong>
              </b-col>
              <b-col :md="7">
                {{ data.amount }}
              </b-col>

              <!-- RESUMEN -->
              <b-col :md="5">
                <strong> {{ $t("form.price") }}: </strong>
              </b-col>
              <b-col :md="7"> {{ data.price }} MP </b-col>

              <!-- START_DATE -->
              <b-col :md="5">
                <strong> {{ $t("duration") }}: </strong>
              </b-col>
              <b-col :md="7"> {{ data.duration }} {{ $t("days") }} </b-col>

              <!-- END_DATE -->
              <b-col :md="5">
                <strong> {{ $t("max-ads") }}: </strong>
              </b-col>
              <b-col :md="7">
                {{ data.max_ads_creation }}
              </b-col>

              <!-- NVIEWS -->
              <b-col :md="5">
                <strong> {{ $t("form.description") }}: </strong>
              </b-col>
              <b-col :md="7">
                <p>
                  {{ data.description }}
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr />

        <b-row class="text-center">
          <b-col md="3">
            <h5>{{ $t("active_users") }}</h5>
            <h2>{{ stadistic.active_users }}</h2></b-col
          >
          <b-col md="3">
            <h5>{{ $t("created_ads") }}</h5>
            <h2>{{ stadistic.created_ads }}</h2>
          </b-col>
          <b-col md="3">
            <h5>{{ $t("total_sales") }}</h5>
            <h2>{{ stadistic.total_sales }}</h2></b-col
          >
          <b-col md="3">
            <h5>{{ $t("amount_earned") }}</h5>
            <h2>{{ stadistic.amount_earned }}</h2>
          </b-col>
        </b-row>
      </b-overlay>
    </b-form>
    <template #modal-footer>
      <!-- <b-button size="sm" variant="primary" @click="onSubmit()">
        {{ $t("save") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        @click="$bvModal.hide('bv-modal-advertising-show')"
      >
        {{ $t("close") }}
      </b-button> -->
    </template>
  </b-modal>
</template>

<script>
import { myRendeImage } from "@/directives/render-Image";
import { mapActions, mapGetters } from "vuex";
export default {
  mixins: [myRendeImage],
  data() {
    return {
      data: {
        id: "",
        name: "",
        amount: "",
        price: "",
        duration: "",
        max_ads_creation: "",
        description: "",
      },
      preview: "",
    };
  },
  methods: {
    ...mapActions({
      fetchPromotionsStats: "fetchPromotionsStats",
    }),
    async show(item) {
      this.formReset();
      this.preview = require("@/assets/img/brand/no-image.jpg");
      if (item) {
        this.data = item;
        this.preview = item.image
          ? this.imageData(item.image)
          : require("@/assets/img/brand/no-image.jpg");
        this.fetchPromotionsStats(item.id);
        console.log(this.stadistic);
      }
      this.$bvModal.show("bv-modal-advertising-show");
    },
    formReset() {
      this.data = {
        id: "",
        name: "",
        amount: "",
        price: "",
        duration: "",
        max_ads_creation: "",
        description: "",
      };
    },
    previewImagen(image) {
      this.$viewerApi({
        images: [image],
      });
    },
  },
  computed: {
    ...mapGetters({
      promotionsLoading: "promotionsLoading",
      stadistic: "getPromotionsStats",
    }),
    columns() {
      return [
        {
          label: this.$t("active_users"),
          key: "active_users",
          class: "text-center",
        },
        {
          label: this.$t("created_ads"),
          key: "created_ads",
          class: "text-center",
        },
        {
          label: this.$t("total_sales"),
          key: "total_sales",
          class: "text-center",
        },
        {
          label: this.$t("amount_earned"),
          key: "amount_earned",
          class: "text-right",
        },
      ];
    },
  },
};
</script>

<style>
.vs__selected {
  color: gray;
}
.vs__dropdown-toggle {
  border: none;
}
</style>
